import { useMsal } from "@azure/msal-react";

export function useUserName() {
    const { accounts } = useMsal();
    const userName = accounts?.[0]?.username || accounts?.[0]?.name || "unknown";
    return userName;
}
